import React from "react";
import { translate } from "../../utils/translations/translate";
import { StyledCreateTimesheetContainer } from "./styles";
import { WeekPicker } from "../DatePicker/WeekPicker";
import Button from "../UI/Button";
import { Popupmenu } from "../UI/PopupMenu";
import { DOWNLOAD_OPTIONS } from "../../utils/constants";
import TimesheetDetails from "./TimesheetDetails";
import { useTimesheetActions } from "./hooks/useTimesheetActions";
import { Loader } from "../Loader/Loader";
import { Alert } from "../UI/Alert";
import { TimesheetViewMode } from "./TimesheetViewMode";
const TimesheetEntry = () => {
  const {
    error,
    isLoading,
    projectTasksList,
    selectedWeek,
    handleWeekChange,
    weekDaysArr,
    projectsList,
    toastInfo,
    syncTimesheetDetails,
    handleTimesheetSubmitActions,
    handleTimesheetModeChange,
    showDraftAction,
    showSubmitButton,
    generateTimesheetReport,
    onCopyPreviousWeekTimesheet,
    handleToastClose,
    hideServiceError,
    onDeleteAttachment,
  } = useTimesheetActions();
  return (
    <StyledCreateTimesheetContainer>
      {error && (
        <Alert type={"error"} message={error} onToastClose={hideServiceError} />
      )}
      {toastInfo && <Alert {...toastInfo} onToastClose={handleToastClose} />}
      <header className="tma_timesheet_header">
        <div className="tma_primary_row">
          <h1 className="page-title">{translate("pageTitles.timeSheet")}</h1>
          {projectsList.length > 0 && (
            <div className="tma_submit_actions">
              {showDraftAction && (
                <Button
                  type="button"
                  className={"tma_time_draft_btn primary-outline"}
                  text={translate("labels.saveAsDraft")}
                  onClick={() => {
                    handleTimesheetSubmitActions("Draft");
                  }}
                />
              )}
              {showSubmitButton && (
                <Button
                  type="button"
                  className={"tma_time_submit_btn"}
                  variantStyle="primary"
                  text={translate("labels.submitForApproval")}
                  onClick={() => {
                    handleTimesheetSubmitActions("Submit");
                  }}
                />
              )}
              <Popupmenu
                type="button"
                popupOptions={DOWNLOAD_OPTIONS}
                variantStyle="secondary"
                label={translate("labels.moreOptions")}
                onOptionSelect={({ key }) => {
                  generateTimesheetReport(key);
                }}
              />
              <WeekPicker onChange={handleWeekChange} disableFuture={true} />
            </div>
          )}
        </div>
      </header>
      {projectsList.map((project) => {
        if (project.mode === "read") {
          return (
            <TimesheetViewMode
              onModeChange={handleTimesheetModeChange}
              isEditable={project.isEditable}
              key={project.projectId}
              projectSavedData={project}
              taskRows={project.timesheetData}
              projectId={project.projectId}
              managerName={project.managerName}
              managerEmail={project.managerEmail}
              taskList={projectTasksList}
              selectedWeek={selectedWeek}
              weekDaysArr={weekDaysArr}
              projectName={project.projectName}
              approverComments={project.approverComments}
              status={project.status}
            />
          );
        }
        return (
          <TimesheetDetails
            syncTimesheetDetails={syncTimesheetDetails}
            onModeChange={handleTimesheetModeChange}
            key={`${project.projectId}-${selectedWeek.firstDay.toDateString()}`}
            showCopyButton={project.showCopyButton}
            projectSavedData={project}
            taskRows={project.timesheetData}
            showEditExit={project.showEditSwitch}
            projectId={project.projectId}
            projectName={project.projectName}
            managerName={project.managerName}
            managerEmail={project.managerEmail}
            taskList={projectTasksList}
            selectedWeek={selectedWeek}
            weekDaysArr={weekDaysArr}
            approverComments={project.approverComments}
            status={project.status}
            onCopyPreviousTimesheet={onCopyPreviousWeekTimesheet}
            savedAttachments={project.attachments}
            onDeleteAttachment={onDeleteAttachment}
          />
        );
      })}
      {isLoading && projectsList.length === 0 && (
        <p>{translate("labels.fetchingTimesheetInfo")}</p>
      )}
      {isLoading && <Loader />}
    </StyledCreateTimesheetContainer>
  );
};

export default TimesheetEntry;
